import { request } from 'utils/ajax';

export function getFeatureDefinitions(): Promise<FeatureDefinitionDTO[]> {
    return request(`api/FeatureDefinition`).then((x) => x.json());
}
export function setToggleForAll(featureName: string, toggle: boolean | null): Promise<void> {
    return request(`api/FeatureDefinition/${featureName}/toggle-for-all`, {
        method: 'PATCH',
        body: { toggleForAll: toggle },
        json: true,
    }).then((x) => x.json());
}

export interface FeatureDefinitionDTO {
    featureName: string;
    isPaid: boolean;
    information: string;
    isExperimental: boolean;
    isProfileOnlyFeature: boolean;
    toggleForAll?: boolean;
}


export interface FeatureInfo extends FeatureDefinitionDTO {
    toggled?: boolean;
}
